import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children, allowedRoles }) => {
  const userId = localStorage.getItem("user_id");
  const roleId = Number(localStorage.getItem("role_id"));

  if (!userId) {
    return <Navigate to="/" replace />;
  }
  if (allowedRoles && !allowedRoles.includes(roleId)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default ProtectedRoute;
